// =============================================================================
//  ⚙️  FICHIER UNIQUE À ÉDITER — TOUT LE CONTENU DU SITE EST ICI
// -----------------------------------------------------------------------------
//  Tout ce qui est marqué  ⚠️  est un PLACEHOLDER à remplacer par les vraies
//  infos du client (nom, prix, téléphone, lien Calendly, témoignages...).
//  Tu peux tout modifier sans toucher au code des composants.
// =============================================================================

// ----------------------------------------------------------------------------
//  ENTREPRISE & CONTACT
// ----------------------------------------------------------------------------
export const company = {
  name: "NOM DE L'ENTREPRISE", // ⚠️ Nom commercial affiché (navbar, footer)
  zone: "Toulouse et alentours", // ⚠️ Zone d'intervention
  email: "contact@exemple.fr", // ⚠️ Email de contact

  // Téléphone — bouton "Appeler"
  phone: "+33600000000", // ⚠️ Format international, sans espaces (lien tel:)
  phoneDisplay: "06 00 00 00 00", // ⚠️ Version lisible affichée

  // WhatsApp — bouton flottant
  whatsapp: "33600000000", // ⚠️ Indicatif + numéro SANS le "+" ni le "0" (lien wa.me)
  whatsappMessage: "Bonjour, je souhaite des informations sur la reprogrammation de mon véhicule.", // message pré-rempli
};

// ----------------------------------------------------------------------------
//  NAVIGATION (ancres vers les sections)
// ----------------------------------------------------------------------------
export const navLinks = [
  { label: "Prestations", href: "#prestations" },
  { label: "Avantages", href: "#avantages" },
  { label: "Processus", href: "#processus" },
  { label: "Avis", href: "#temoignages" },
];

// ----------------------------------------------------------------------------
//  HERO (section vidéo plein écran)
// ----------------------------------------------------------------------------
export const hero = {
  badge: "Reprogrammation moteur sur-mesure",
  title: "Libérez la vraie puissance de votre moteur",
  subtitle:
    "Cartographie moteur personnalisée pour plus de puissance, de couple et un meilleur rendement. Réalisée sur banc, en toute sécurité.",
  ctaPrimary: "Prendre rendez-vous", // scrolle vers la section RDV
  ctaSecondary: "Voir les prestations", // scrolle vers les prestations
};

// ----------------------------------------------------------------------------
//  PRESTATIONS (cartes services) — prix = PLACEHOLDERS
// ----------------------------------------------------------------------------
export const services = [
  {
    name: "Stage 1",
    description:
      "Optimisation moteur d'origine : plus de puissance et de couple, sans modification mécanique.",
    price: "à partir de 299€", // ⚠️ prix placeholder
  },
  {
    name: "Stage 2",
    description:
      "Reprogrammation poussée pour véhicules modifiés (échappement, admission, intercooler...).",
    price: "à partir de 499€", // ⚠️ prix placeholder
  },
  {
    name: "Flex Fuel E85",
    description:
      "Conversion au superéthanol E85 : roulez moins cher tout en gardant les performances.",
    price: "à partir de 349€", // ⚠️ prix placeholder
  },
  {
    name: "FAP / EGR Off",
    description:
      "Traitement des systèmes FAP et EGR pour fiabiliser le moteur. Usage circuit / export.",
    price: "à partir de 249€", // ⚠️ prix placeholder
  },
  {
    name: "Stop & Start Off",
    description:
      "Désactivation définitive du Stop & Start pour plus de confort de conduite.",
    price: "à partir de 79€", // ⚠️ prix placeholder
  },
  {
    name: "Décatalyseur",
    description:
      "Suppression catalyseur et adaptation de la cartographie. Usage circuit / export.",
    price: "à partir de 199€", // ⚠️ prix placeholder
  },
];

// ----------------------------------------------------------------------------
//  AVANTAGES (pourquoi nous) — icône = nom du pictogramme (voir Advantages.jsx)
// ----------------------------------------------------------------------------
export const advantages = [
  {
    icon: "power",
    title: "Gain de puissance",
    description: "Jusqu'à +30% de puissance et de couple selon le véhicule.",
  },
  {
    icon: "fuel",
    title: "Économie de carburant",
    description: "Une conduite plus souple et un moteur optimisé pour consommer moins.",
  },
  {
    icon: "dyno",
    title: "Banc de puissance",
    description: "Chaque cartographie est validée et mesurée sur banc de puissance.",
  },
  {
    icon: "shield",
    title: "Garantie",
    description: "Travail soigné et garanti, sauvegarde du fichier d'origine systématique.",
  },
];

// ----------------------------------------------------------------------------
//  PROCESSUS EN 3 ÉTAPES
// ----------------------------------------------------------------------------
export const processSteps = [
  {
    step: "01",
    title: "Je réserve",
    description: "Choisissez votre créneau en ligne en quelques secondes.",
  },
  {
    step: "02",
    title: "Je dépose mon véhicule",
    description: "Diagnostic, sauvegarde d'origine et reprogrammation sur place.",
  },
  {
    step: "03",
    title: "Je récupère la puissance",
    description: "Récupérez votre véhicule optimisé et profitez de la différence.",
  },
];

// ----------------------------------------------------------------------------
//  TÉMOIGNAGES (avis clients) — ⚠️ fictifs, à remplacer par de vrais avis
// ----------------------------------------------------------------------------
export const testimonials = [
  {
    name: "Julien M.", // ⚠️
    car: "Golf 7 GTD",
    rating: 5,
    text: "Différence énorme dès la première accélération. Travail propre et pro, je recommande à 100%.",
  },
  {
    name: "Sarah L.", // ⚠️
    car: "Audi A3 2.0 TDI",
    rating: 5,
    text: "Passée au Flex E85, je fais le plein pour bien moins cher et la voiture répond mieux. Top !",
  },
  {
    name: "Karim B.", // ⚠️
    car: "BMW 320d",
    rating: 5,
    text: "Accueil au top, explications claires et résultat mesuré sur banc. Rien à dire.",
  },
];

// ----------------------------------------------------------------------------
//  SECTION RENDEZ-VOUS (calendrier de démonstration)
// ----------------------------------------------------------------------------
export const booking = {
  title: "Réservez votre créneau",
  subtitle:
    "Prise de rendez-vous en ligne en quelques clics. Choisissez le jour et l'horaire qui vous conviennent.",

  // --- Réglages du calendrier de démo (entièrement modifiables) ---
  // Créneaux horaires proposés chaque jour ouvré
  slots: ["09:00", "10:00", "11:00", "14:00", "15:00", "16:00", "17:00"],
  // Jours fermés (0 = dimanche, 1 = lundi, ... 6 = samedi)
  closedDays: [0], // fermé le dimanche
  // Délai mini avant un RDV (en jours) — 0 = aujourd'hui possible
  minLeadDays: 1,

  // ⚠️  PASSAGE EN PRODUCTION (plus tard) :
  // Pour de vraies réservations avec acompte + notifications, remplace le
  // composant <BookingCalendar/> par un iframe Calendly dans Booking.jsx,
  // et renseigne le vrai lien ci-dessous.
  // Exemple : "https://calendly.com/nom-du-client/reprogrammation"
  calendlyUrl: "https://calendly.com/placeholder",
};

// ----------------------------------------------------------------------------
//  FOOTER
// ----------------------------------------------------------------------------
export const footer = {
  tagline: "Reprogrammation moteur & cartographie automobile.",
  legal: `© ${new Date().getFullYear()} NOM DE L'ENTREPRISE — Tous droits réservés.`, // ⚠️
  notice:
    "Certaines prestations (FAP/EGR Off, Décatalyseur) sont réservées à un usage circuit ou export.",
};
